<template>
  <div>
    <legend>Información curricular</legend>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <p-radio  class="d-inline-block" name="conest" v-model="estudios_sn" :inline=true label="1">Con Estudios</p-radio>
          <p-radio  class="d-inline-block" name="conest" v-model="estudios_sn" :inline=true label="2">Sin Estudios</p-radio>
        </div>
      </div>
    </div>
    <div v-if="add_item">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="control-label">
              Nivel:
            </label>
            <el-select  clearable class="select-default" filterable name="grado_maximo" placeholder="Escolaridad" v-validate="'required'" v-model="model.grado_maximo_escolaridad_id">
              <el-option v-for="option in gradoesc" class="select-default" filterable :value="option.id" :label="option.grado_escolaridad" :key="option.grado_escolaridad">
              </el-option>
            </el-select>
            <small class="text-danger" >
              {{ getError('grado_maximo') }}
            </small>
          </div>
        </div>
        <div class="form-group col-md-8" v-if="muestraCampos">
          <label class="control-label">
            Grado obtenido:
          </label>
          <input class="form-control" type="text" name="grado_obtenido" v-validate="'required'" v-model="model.grado_obtenido" placeholder="Grado Obtenido" />
          <small class="text-danger" >
            {{ getError('grado_obtenido') }}
          </small>
        </div>

      </div>
      <h5 class="text-left">Institución Educativa</h5>
      <div class="row">
        <div class="col-md-8">
          <div class="form-group">
            <label class="control-label">
              Institución
            </label>
            <input class="form-control" type="text" name="institucion_educativa" v-model="model.institucion_educativa" placeholder="Nombre de la institución" />
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">
              Carrera o área de conocimiento:
            </label>
            <input class="form-control" type="text" name="carrera" v-model="model.carrera" placeholder="Carrera o área de conocimiento" />
          </div>
        </div>
        <div class="col-md-12 form-group">
          <label class="control-label">
            Estatus
          </label>
          <el-select  clearable class="select-default" filterable placeholder="Estatus" name="estatus" v-validate="'required'" v-model="model.estatus_id">
            <el-option v-for="option in estatusC" class="select-default" :value="option.id" :label="option.estatus" :key="option.codigo">
            </el-option>
          </el-select>
          <small class="text-danger" >
            {{ getError('estatus') }}
          </small>
        </div>
        <div class="col-md-12 form-group" v-if="model.estatus_id >'1'">
          <label class="control-label">
            Documento Obtenido:
          </label>
          <el-select  clearable class="select-default" placeholder="Documento" filterable v-model="model.documento_obtenido_id">
            <el-option v-for="option in documentos" class="select-default" :value="option.id" :label="option.documento" :key="option.codigo">
            </el-option>
          </el-select>
        </div>
        <div class="col-md-6 " v-if="model.estatus_id >'1'">
          <label class="control-label">
            Fecha de obtención del documento
          </label>
          <div class="form-group">
            <el-date-picker value-format="dd-MM-yyyy" format="dd-MM-yyyy" name="fecha_obtencion"  v-validate="'required'" v-model="model.fecha_obtencion" :picker-options="opciones" type="date" placeholder="Selecciona">
              </el-date-picker>
          </div>
          <div class="col-md-6 " v-if="model.documento_obtenido_id =='6'">
              <label class="control-label">
                Cédula Profesional
              </label>
              <input class="form-control" type="text" name="cedula_profesional" v-model="model.cedula_profesional" placeholder="Cédula" />
          </div>
          <div class="form-group">
            
          </div>
        </div>
        <!---se oculta desde aqui--->
        <!--
        <div style="display:none">
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">
                Entidad Federativa/Pais si es extranjero:
              </label>
              <div v-if="model.lugar_institucion_ext =='1'">
                <el-select  clearable class="select-default" placeholder="Entidad Federativa" filterable name="entidad" v-validate="'required'" v-model="model.lugar_institucion_educativa_entidad_id">
                  <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
                  </el-option>
                </el-select>
                <small class="text-danger">
                  {{ getError('entidad') }}
                </small>
              </div>

              <div v-if="model.lugar_institucion_ext =='2'">
                <el-select  clearable class="select-default" placeholder="Pais " filterable name="pais" v-model="model.lugar_institucion_educativa_pais_id">
                  <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
                  </el-option>
                </el-select>
              </div>

            </div>
          </div>

          <div class="col-md-4 form-group">
            <label class="control-label">
              Periodos Cursados (Tipo)
            </label>
            <el-select  clearable class="select-default" filterable placeholder="Periodos" name="periodos" v-model="model.periodos_cursados_id">
              <el-option v-for="option in periodosC" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">
                Periodos Cursados (Número)
              </label>
              <input class="form-control" type="text" name="periodos_cursados" v-model="model.periodos_cursados" placeholder="Periodos Cursados" />
            </div>
          </div>


          <div class="col-md-4" v-if="muestraCampos">
            <div class="form-group">
              <label class="control-label">
                Año de conclusión:
              </label>
              <input class="form-control" type="text" name="ano_conclusion" v-model="model.ano_conclusion" placeholder="Año" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="control-label">
                Cédula Profesional
              </label>
              <input class="form-control" type="text" name="cedula_profesional" v-model="model.cedula_profesional" placeholder="Cédula" />
            </div>
          </div>
        </div>
        -->
        <!---Termina ocultos--->
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              Ubicación
            </label>
            <p-radio  class="d-inline-block" name="lugar" v-validate="'required'" v-model="model.lugar_institucion_ext" label="1">México</p-radio>
            <p-radio   class="d-inline-block" name="lugar" v-validate="'required'" v-model="model.lugar_institucion_ext" label="2">Extranjero</p-radio>

            <small class="text-danger" >
              {{ getError('lugar') }}
            </small>
          </div>
        </div>
        <div class=" col-md-12">
          <div class="form-group">

            <label>Aclaraciones y observaciones</label>
            <textarea class="form-control" type="text" name="aclaraciones" v-model="model.aclaraciones" placeholder="Aclaraciones y observaciones"></textarea>
          </div>
        </div>
      </div>
      <!--tabla para agregar y editar-->
      <div class="row justify-content-end m-3">
        <button class="btn btn-success" @click.prevent="addItem()">
          <span>
            <i class="fa fa-save"></i> Guardar
          </span>
        </button>
        <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
          <span>
            <i class="fa fa-times"></i> Cancelar
          </span>
        </button>
      </div>

      <!--Tablas-->
    </div>
    <div v-if="(estudios_sn ==1)&&!add_item">

      <div class="row justify-content-end m-3">
        <button class="btn btn-primary" @click.prevent="showItem()">
          <span>
            <i class="fa fa-plus"></i> Agregar
          </span>
        </button>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <v-data-table :headers="headers" :items="list_escolaridad" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger" :disabled="edit_item != null">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.grado_maximo_escolaridad_id="{ item }">
                <div>{{getGrado(item.grado_maximo_escolaridad_id)}}</div>
              </template>

              <template v-slot:item.carrera="{ item }">
                <div>{{item.carrera}}</div>
              </template>
              <template v-slot:item.cedula_profesional="{ item }">
                <div>{{item.cedula_profesional}}</div>
              </template>

            </v-data-table>
              <!--
                <b-table id="tbl_exp" responsive hover :items="list_escolaridad" :fields="fields_list">
                  <template slot="acciones" slot-scope="row" class="actions">
                    <b-button size="sm" @click.prevent="editItem(row)" class="edit mr-2" :disabled="edit_item != null">
                      Editar <i class="fas fa-pencil-alt ml-2"></i>
                    </b-button>
                    <b-button size="sm" @click.prevent="removeItem(row.index)" class="delete mr-2" :disabled="edit_item != null">
                      Eliminar <i class="fas fa-trash-alt ml-2"></i>
                    </b-button>
                  </template>
                  <template slot="empty">
                    <h5>No existen registros</h5>
                  </template>

                  <div slot="grado_maximo_escolaridad_id" slot-scope="row" class="text-right">{{getGrado(row.item.grado_maximo_escolaridad_id)}}</div>
                  <div slot="institucion_educativa" slot-scope="row">{{row.item.institucion_educativa}}</div>
                  <div slot="carrera" slot-scope="row">{{row.item.carrera}}</div>
                  <div slot="cedula_profesional" slot-scope="row">{{row.item.cedula_profesional}}</div>
                </b-table>
              -->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker
  } from 'element-ui'


  import Domicilio from '../Domicilio.vue'

  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker
      ,inject: ['$validator'],

    },

    data() {
      return {
        DatePicker: '',
        muestraCampos: false,
        ip_id: null,
        estudios_sn: '2',
        list_escolaridad: [],
        edit_item: null,
        add_item: false,
        model: {
          lugar_institucion_ext: '1'

        },
        opciones: {
          disabledDate(date) {
            return date > new Date();
          }
        },
        gradoesc: [],
        documentos: {},
        estatusC: {},
        periodosC: {},
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Grado Escolaridad',
          value: 'grado_maximo_escolaridad_id',
          align: 'center',
        }, {
          text: 'Institución Educativa',
          value: 'institucion_educativa',
          align: 'center',
        }, {
          text: 'Carrera',
          value: 'carrera',
          align: 'center',
        }, {
          text: 'Cédula Profesional',
          value: 'cedula_profesional',
          align: 'center',
        },  ],
        info: {
          grado_maximo_escolaridad_id: 'Este apartado solo lo llenaran las personas servidoras públicas que tengan participación en un fideicomiso, ya sea en el carácter de fideicomitente, fiduciario, fideicomisario o dentro del consejo técnico. Deberá reportar hasta los últimos dos años.',
          institucion_educativa: 'Elegir quien es el participante en el fideicomiso, el Declarante, Pareja o dependiente económico.',
          carrera: 'Seleccionar si es público, privado o mixto.',
          cedula_profesional: 'Seleccionar su participación como fideicomitente, fiduciario, fideicomisario o dentro del Comité Técnico.',
          rfc_fideicomiso: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomiso.',
          fideicomitente: 'Seleccionar si es persona física o persona moral.',
          nombre_fideicomitente: 'Proporcionar nombre completo.',
          rfc_fideicomitente: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomitente.',
          nombre_fiduciario: 'Proporcionar nombre completo.',
          rfc_fiduciario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fiduciario.',
          fideicomisario: 'Seleccionar si es persona física o persona moral.',
          nombre_fideicomisario: 'Proporcionar nombre completo.',
          rfc_fideicomisario: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del fideicomisario.',
          sector: 'Elegir el sector al que pertenece.',
          lugar: 'Seleccionar en México o en el extranjero.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },


      }
    },
    mounted() {
      this.model.lugar_institucion_ext = '1';
      this.ip_id = this.getId();
      this.gradosEsc();
      this.getDatosC();
      this.documentoObt();
      this.getEstatusCarr();
      this.periodosCursados();
      this.model.fecha_obtencion = '';
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll()
      },
      getDatosC() {
        var v = this;
        this.$http.get('datosCurric/' + this.ip_id).then(
          response => {
            if (response.data.datosCurr.length > 0) {
              this.list_escolaridad = response.data.datosCurr;
              this.estudios_sn = '1';
            } else {
              this.estudios_sn = '2';
            }
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },


      documentoObt() {
        this.$http.get('doctoObt').then(
          response => {
            this.documentos = response.data.documentoOb;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      gradosEsc() {
        this.$http.get('gradoesc').then(
          response => {
            this.gradoesc = response.data.grado;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      periodosCursados() {
        this.$http.get('periodosC').then(
          response => {
            this.periodosC = response.data.periodos;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      getEstatusCarr() {
        this.$http.get('estatuscarr').then(
          response => {
            this.estatusC = response.data.estatusC;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        )
      },
      cancelEdit() {

        this.limpiaCampos();
        this.showItem();
        this.edit_item = null;
      },
      editItem(item) {
        this.showItem();
        this.model = item;
       /* this.model = {
          ...this.list_escolaridad[this.edit_item.index]
        };
        */
        var v = this;
       // this.edit_item.item._rowVariant = "warning";
        $(".main-panel").animate({
            scrollTop: 1300
          },
          500,
          "swing"
        );
      },

      getGrado(index) {
        var resp = "";
        if (this.gradoesc) {
          this.gradoesc.forEach(function (item) {
            if (item.id == index) {
              resp = item.grado_escolaridad;
              return resp;
            }
          });
        }
        return resp;
      },
      addItem() {
        console.log(1);
        console.log(this.$validator.validateAll());
        this.$validator.validateAll().then(
          response => {
            console.log(2);
            console.log(response);
            if (response) {
              this.loadButton(this.$refs.btnSave);
              this.$http.put('datosCurric/' + this.ip_id, this.model).then(
                response => {
                  this.StepOk("Guardado");
                  /* this.origen_tramites = JSON.parse(JSON.stringify(response.data.tramite));
                  eventBus.$emit("TramiteSaved", response.data.tramite);
                  this.envioRespuesta(true); */
                  if (this.edit_item === undefined || this.edit_item === null) {
                    this.list_escolaridad.push({
                      ...this.model
                    });
                  } else {
                    this.list_escolaridad.splice(
                      this.edit_item.index,
                      1,
                      this.model
                    );
                   // this.edit_item.item._rowVariant = "";
                  }

                  this.showItem();
                  this.limpiaCampos();
                  this.edit_item = null;
                  this.getDatosC();
                },
                error => {
                  this.StepError(error);
                  //this.change =  true;
                }
              );
            } else {
              this.StepW("Hay campos sin completar");
            }
          }
        );
      },
      showItem() {
        this.add_item = !this.add_item;
      },
/*       removeItem(indice) {
        if (this.list_escolaridad[indice].id !== null) {

          let item = this.list_escolaridad[indice];
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("datosCurric/" + item.id).then(
              response => {
                /* eventBus.$emit("TramiteDelete", item);
                this.list_escolaridad.splice(indice, 1);
                this.OK("Registro eliminado");
              },
              error => {
                this.Err(error);
              }
            );
          });
        } else {
          this.Ask("Desea borrar este registro", () => {
            this.list_escolaridad.splice(indice, 1);
          });
        }
      }, */
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("datosCurric/" + item.id).then(
              response => {
                let index = this.list_escolaridad.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.list_escolaridad.splice(index, 1);
                this.StepOk('Registro eliminado');
              }, error => {
                this.Err(error);
              });
          });
        }
      },
      limpiaCampos() {
        this.model = {
          grado_maximo_escolaridad_id: '',
          grado_obtenido: '',
          institucion_educativa: '',
          lugar_institucion_ext: '1',
          lugar_institucion_educativa_entidad_id: '',
          carrera: '',
          periodos_cursados_id: '',
          estatus_id: '',
          cedula_profesional: '',
          fecha_obtencion: ''

        };
      }
    }
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Personal/DatosCurriculares.vue